import { Component, ElementRef } from '@angular/core';
import { encodeHtmlContent } from '@core/operators';

const properties = [
  'margin',
  'padding',
  'border-style',
  'border-color',
  'border-width',
  'border-radius',
  'position',
  'display',
  'flex',
  'align-items',
  'align-self',
  'justify-content',
  'opacity',
  'font-family',
  'font-size',
  'font-style',
  'font-weight',
  'font-variant',
  'line-height',
  'text-align',  
  'vertical-align',
  'text-transform',
  'color',
  'background-color',
  'width',
  'height',
  'max-width',
  'max-height',
  'min-width',
  'min-height',
  'box-sizing',
  'text-decoration',
  'box-shadow',
  'content'
]

function copy(dest: HTMLElement, src: HTMLElement, lookup: { elements: any, count: number }, override?: any) {

  let css = window.getComputedStyle(src);

  properties.forEach(i => {
    let key = i + ':' + (override && override[i] ? override[i] : css[i]);
    if (!lookup.elements[key]) lookup.elements[key] = 's' + (++lookup.count);
    dest.classList.add(lookup.elements[key]);
  });

  let test = window.getComputedStyle(src, '::before');
  if (test.content != 'none') {

    let key = properties.filter(i => css[i] != test[i]).map(i => i + ':' + test[i]).join(';');

    if (key.length > 1) {
      if (!lookup.elements[key]) lookup.elements[key] = 's' + (++lookup.count) + '::before';
      dest.classList.add(lookup.elements[key].split(':')[0]);
    }
  }

  test = window.getComputedStyle(src, '::after');

  if (test.content != 'none') {

    let key = properties.filter(i => css[i] != test[i]).map(i => i + ':' + test[i]).join(';');

    if (key.length > 1) {
      if (!lookup.elements[key]) lookup.elements[key] = 's' + (++lookup.count) + '::after';
      dest.classList.add(lookup.elements[key].split(':')[0]);
    }
  }
}

function clone(element: ChildNode, lookup: { elements: any, count: number } = { elements: {}, count: 0 }): Node {
  
  if (!(element as HTMLElement).tagName) {
    return element.cloneNode(true);
  }

  let result: HTMLElement = document.createElement((element as HTMLElement).tagName);

  if (element['href']) result['href'] = element['href'];
  if (element['target']) result['target'] = element['target'];

  copy(result, element as HTMLElement, lookup);
  
  for (let i = 0; i < element.childNodes.length; i++) {
    if (element.childNodes[i].nodeType != Node.COMMENT_NODE) {
      result.appendChild(clone(element.childNodes[i], lookup));
    }
  }

  return result;
}

@Component({
  selector: 'sharable-content',
  templateUrl: './sharable-content.component.html',
  styleUrls: ['./sharable-content.component.scss']
})
export class SharableContentComponent {

  private clone(lookup: { elements: any, count: number }): HTMLElement {
    let children = (this.ref.nativeElement as HTMLElement).childNodes;
    let container = document.createElement('div');

    for (let i = 0; i < children.length; i++) {
      if (children[i].nodeType != Node.COMMENT_NODE) {
        container.appendChild(clone(children[i], lookup));
      }
    }

    return container;

  }

  public html(configs?: SharableHtmlConfigs): string {

    let lookup = { elements: {}, count: 0 };
    let clone = this.clone(lookup);

    let styles = '';

    for (let o in lookup.elements) styles += '.' + lookup.elements[o] + '{' + o + '}';

    let result = [

      '<!doctype html>',
      '<html' + (configs && configs.language ? ' lang="' + configs.language + '"' : '') + '>',
      '<head>',
      '<meta charset="utf-8">',
      configs && configs.title ? '<title>' + encodeHtmlContent(configs.title) + '</title>' : '',
      '<meta name="viewport" content="minimal-ui, width=device-width, initial-scale=1"/>',
      configs && configs.language ? '<meta http-equiv="Content-Language" content="' + configs.language + '">' : '',
      '<meta name="google" content="notranslate">',
      configs && configs.description ? '<meta name="description" content="' + encodeHtmlContent(configs.description) + '"/>' : '',
      configs && configs.iconUrl ? '<link rel="icon" type="image/x-icon" href="' + configs.iconUrl + '">' : '',
      configs && configs.fontCssUrls ? configs.fontCssUrls.map(i => '<link rel="stylesheet" href="' + i + '">').join('') : '',
      '<style>' + styles + '</style>',
      '<head>',
      '<body>',
      clone.innerHTML,
      '</body>',
      '</html>'

    ].join('');

    return result;
  }

  constructor(private ref: ElementRef) { }
}

export interface SharableHtmlConfigs {
  iconUrl?: string;
  title?: string;
  description?: string;
  language?: string;
  fontCssUrls?: string[];  
}
